import {getAuthClient, AuthClientInstance} from "@trumpf/ux.utils";
import {store as notificationsStore, subscribe as subscribeNotifications} from "../stores/notification-handler-store";
import {getUserSettings, subscribeAssets, store as userSettingsStore} from "../stores/user-settings-handler-store";
import {STAGE} from "@trumpf/notifies.notification-handler";

let subscriptionCounter = 0;

let unsubscribeAuthCallback: () => void | null = null;
let unsubscribeNotificationsCallback: () => void | null = null;
let unsubscribeAssetsCallback: () => void | null = null;

const _log = (debug: boolean, msg: string) => {
	if (debug && console && typeof console.log === "function") {
		const now = new Date();
		const timestamp = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getMilliseconds()}`;
		console.log(`[Notification Center] ${timestamp}: ${msg}`);
	}
};

const TOKEN_WAIT_TIMEOUT = 20000;
export async function AuthSubscribe(version: string, env: string, locale: string, debug: boolean) {
	subscriptionCounter++;

	const startTime = Date.now();
	_log(debug, `Token retrieve starting`);

	const authClientNotifications: AuthClientInstance = getAuthClient("notificationmanagement");

	unsubscribeAuthCallback = authClientNotifications.subscribe((newToken: string | null) => {
		if (newToken) {
			notificationsStore.set("token", newToken);
			userSettingsStore.set("token", newToken);
			const endTime = Date.now();
			const timeTaken = endTime - startTime;
			_log(debug, `Received new token from remote in ${timeTaken}ms`);

			getUserSettings(newToken, locale, version, STAGE[env], () => {
				unsubscribeNotificationsCallback = subscribeNotifications(newToken, locale, version, STAGE[env]);
				unsubscribeAssetsCallback = subscribeAssets(newToken, "1.0", STAGE[env]);
			});
		}
	});

	const initialToken = authClientNotifications.getAccessToken();
	if (initialToken) {
		notificationsStore.set("token", initialToken);
		userSettingsStore.set("token", initialToken);
		_log(debug, `Subscribing to auth events for environment ${env} (${STAGE[env]})`);

		getUserSettings(initialToken, locale, version, STAGE[env], () => {
			unsubscribeNotificationsCallback = subscribeNotifications(initialToken, locale, version, STAGE[env]);
			unsubscribeAssetsCallback = subscribeAssets(initialToken, "1.0", STAGE[env]);
		});

		_log(debug, `Token found in local state.`);
	} else {
		_log(debug, "No initial token found, waiting for new token.");
		setTimeout(() => {
			if (!notificationsStore.get("token")) {
				_log(debug, "Token wait timed out. No token received within the timeout period.");
				// Set an error state
				notificationsStore.state.error = {
					status: 408, // HTTP 408 Request Timeout
					message: "Token retrieval timed out",
				};
				notificationsStore.set("loading", false);
				userSettingsStore.set("loading", false);
			}
		}, TOKEN_WAIT_TIMEOUT);
	}

	return subscriptionCounter;
}

export function AuthUnsubscribe(subcount: number) {
	if (subcount > 0) return; // don't unsubscribe when there are active subscribers
	if (unsubscribeAuthCallback === null) return;

	unsubscribeAuthCallback();
	unsubscribeNotificationsCallback();
	unsubscribeAssetsCallback();

	//? are the following steps necessary
	notificationsStore.set("notifications", []);
	notificationsStore.set("counter", 0);
	unsubscribeAuthCallback = null;
	unsubscribeNotificationsCallback = null;
	unsubscribeAssetsCallback = null;
}
